import { ClimateRiskRating } from '@/api/rest/resources/types/fact';
import { Logger } from '@/lib/logs/logger';

import { resolveThemeColor } from './resolveThemeColor';

export type RiskStyle = {
  primary: string;
  text: string;
};

export const getStyleForClimateRiskRating = (riskRatingType: ClimateRiskRating): RiskStyle => {
  const exhaustivenessCheck = (ratingType: never): RiskStyle => {
    Logger.error(`No color defined for climate risk rating type "${ratingType}"`);
    return { primary: resolveThemeColor('transparent'), text: resolveThemeColor('transparent') };
  };
  const textColor = resolveThemeColor('text-primary');
  switch (riskRatingType) {
    case ClimateRiskRating.not_relevant:
      return {
        primary: resolveThemeColor('risk-not-relevant'),
        text: textColor,
      };
    case ClimateRiskRating.very_low:
      return {
        primary: resolveThemeColor('risk-very-low'),
        text: textColor,
      };
    case ClimateRiskRating.low:
      return {
        primary: resolveThemeColor('risk-low'),
        text: textColor,
      };
    case ClimateRiskRating.medium:
      return {
        primary: resolveThemeColor('risk-medium'),
        text: textColor,
      };
    case ClimateRiskRating.high:
      return {
        primary: resolveThemeColor('risk-high'),
        text: textColor,
      };
    case ClimateRiskRating.very_high:
      return {
        primary: resolveThemeColor('risk-very-high'),
        text: textColor,
      };
    default:
      return exhaustivenessCheck(riskRatingType);
  }
};

export const getIconForClimateRiskRating = (riskRatingType: ClimateRiskRating): string => {
  const lowRiskIcon = 'ri-arrow-right-down-line';
  const highRiskIcon = 'ri-arrow-right-up-line';
  const mediumRiskIcon = 'ri-arrow-right-line';

  const exhaustivenessCheck = (ratingType: never): string => {
    Logger.error(`No icon defined for climate risk rating type "${ratingType}"`);
    return mediumRiskIcon;
  };
  switch (riskRatingType) {
    case ClimateRiskRating.not_relevant:
      return mediumRiskIcon;
    case ClimateRiskRating.very_low:
      return lowRiskIcon;
    case ClimateRiskRating.low:
      return lowRiskIcon;
    case ClimateRiskRating.medium:
      return mediumRiskIcon;
    case ClimateRiskRating.high:
      return highRiskIcon;
    case ClimateRiskRating.very_high:
      return highRiskIcon;
    default:
      return exhaustivenessCheck(riskRatingType);
  }
};
